import axios from '@/libs/api.request'
import store from '@/store'

export const jumpOnlineService = ()=> {
    // 聊天窗口配置
    const CHAT_WINDOW_CONFIG = {
        name: 'newwindow',
        features: 'height=400,width=400'
    };

    // 默认聊天URL
    const DEFAULT_CHAT_URL = 'http://rcclchina.udesk.cn/im_client/?web_plugin_id=23600';

    const openChatWindow = (url) => {
        window.open(url, CHAT_WINDOW_CONFIG.name, CHAT_WINDOW_CONFIG.features);
    };

    const userToken = store.state.user.token;
    axios.request({
        url: "/api/Udesk/GetWebIMUrl",
        method: "post",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
        },
        params: {
            userName: userToken,
            source: "PC"
        },
    })
    .then((res) => {
        const { errCode, data } = res.data;
        const chatUrl = errCode === 0 && data ? data : DEFAULT_CHAT_URL;
        openChatWindow(chatUrl);
    })
    .catch(() => {
        openChatWindow(DEFAULT_CHAT_URL);
    });
}